<mat-dialog-content style="max-height: 85%">
<div id="w3l-appointment">
  <section class="appointment-section section-gap" style="width: 100%;">
      <div class="wrapper"  >

      <label style="width: 175px;font-size: large;">Current Medication</label>

      <table style="width: 875px;">
        <thead>
            <tr>
                <th style="background-color:  rgb(70, 70, 247);color: white; width: 29%;height: 20%;">Drug</th>
                <th style="background-color:  rgb(70, 70, 247);color: white; width: 29%;height: 20%;">Notes</th>
                <th style="background-color:  rgb(70, 70, 247);color: white; width: 7%;height: 10%;">Dose</th>
                <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 7%;">Unit</th>
                <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;height: 10%;">Frequency</th>
                <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 5%;">Select</th>

            </tr>
        </thead>
        <tbody>

          <tr *ngFor="let cur of currentmedication; let i = index" style="height: 50%;" >
            <td data-column="Patient ID" style="height: 5%;">{{cur.ittname}}</td>
            <td data-column="Patient ID" style="height: 5%;">{{cur.duration}}</td>
            <td data-column="Patient Name"style="height: 30%;">{{cur.dose}}</td>
            <td data-column="Patient Name"style="height: 10%;">{{cur.unname}}</td>
            <td data-column="Patient Name"style="height: 10%;">{{cur.route}}</td>

            <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectCurrent(cur)">Select</button>
          </tr>
        </tbody>
      </table>
      <div class="styled-input">
          <div class="appointment-form-field" style="width: 875px;" disabled ="disablepharnacy">
           <select id="relation" name="relation" style="width: 29%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "drugref" required [disabled]="disablepharnacy">
              <option value="{{itm2.itCode}}"  *ngFor="let itm2 of itemsList2; let i = index">{{itm2.itTName}}</option>
          </select>
          <input type="textarea" name="duration" placeholder="notes" [(ngModel)]= "duration" required="" style="width: 29%;" [disabled]="disablepharnacy"/>
          <input type="textarea" name="dos" placeholder="0" [(ngModel)]= "dose" required="" style="width: 7%;" [disabled]="disablepharnacy"/>
          <select id="department" name="unit" required="" style="width: 10%;background-color: white;" [(ngModel)]="uom" [value]="uom" [disabled]="disablepharnacy">
            <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
          </select>
            <input type="textarea" name="Route" placeholder="0" [(ngModel)]= "route" required="" style="width: 20%;" [disabled]="disablepharnacy"/>
            <button class="fa fa-floppy-o" name="BDrug" placeholder = "0" style="width: 5%;height: 100%;" required (click)="submitCMedication()" [disabled]="disablepharnacy"></button>

            <button class="fa fa-trash" name="BDrug1" placeholder = "0" style="width: 5%;height: 100%;" required (click)="delCurrentMedication_Line()" [disabled]="disablepharnacy"></button>
          </div>

      </div>
      </div>
      <label>                 </label>
       <label style="width: 75px;font-size: large;">Drug interaction</label>
       </section>
      
     <section style="width: 100%;"> 
      
      <BR> <BR> <BR> <BR>
      <div class="appointment-form-field">
        <label>             </label>
        <!-- <span class="fa fa-eye" aria-hidden="true"  style="height: 150%;" ></span>
        <textarea rows = "5" cols = "60" name = "didescription" [(ngModel)]="didescription" class="appointment-form-field" maxlength="250ch" style="width: 64%;height: 150%;" [disabled]="disablepharnacy"></textarea><br> -->
           <angular-editor  [config]="editorConfigNoToolbar"  [placeholder]="'Enter text here...'" [(ngModel)]="dinotes" (ngModelChange)="updatePlainText()"></angular-editor>

      </div>
      </section>
      <section>
      <BR><BR><BR><BR><BR><BR><BR><BR><BR><BR>
      <div class="appointment-form-field" style="width: 100%;">
        <input (change)="picked($event)" type="file" id="photo" name="photo"
        accept="image/*" style="width: 300px;height: 150%;" [disabled]="disablepharnacy">
        <label style="width: 10%;"></label>
        <img src="data:image/jpg;base64,{{myimage}}" (click) = "openDialogViwer()" alt="User Image" width="200px" style="cursor: zoom-in;border: 1px;border-style: inset;" height="180px;padding-top:65px;" />
      </div>
     </section>
      </div>


  <BR><BR><BR><BR><BR>
  <form style="width: 100%;align-items: center;" >
   <div style="width: 100%;align-items: center;text-align: center;" > 
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="Save_Data()" [disabled]="disablepharnacy">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px;font-weight: bold;background-color: rgb(59, 115, 235);color: white;border-style: none;height: 60%;" name="Back" (click)="Print_Home_Medication()" [disabled]="disablepharnacy">{{ 'Print Home Medicatin' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back" (click)="Exit_Data()"  >{{ 'Exit' | translate }}</button>

    <label style="width: 25%;"></label>
    </div>
</form>

</mat-dialog-content>
